import axios from 'axios'
import Cookies from 'js-cookie'
import { action, getter } from '../types'
import Admin from '../../models/Admin'
import moment from 'moment'

let ttl
if (window.Laravel) {
    ttl = moment().add(window.Laravel.ttl, 'minutes').diff(moment(), 'days', true)
}

// state
export const state = {
    user: new Admin({ id: Cookies.get('admin') || 0 }),
    token: Cookies.get('token'),
}

// mutations
export const mutations = {
    [action.AUTH_SAVE_TOKEN](state, { token }) {
        state.token = token
        Cookies.set('token', token, { expires: ttl })
    },

    [action.AUTH_FETCH_USER](state, { user }) {
        state.user = user
        Cookies.set('admin', user.id, { expires: ttl })
    },

    [action.AUTH_LOGOUT](state) {
        state.user = new Admin()
        state.token = null

        Cookies.remove('token')
        Cookies.remove('admin')
    },
}

// actions
export const actions = {
    [action.AUTH_SAVE_TOKEN]({ commit, dispatch }, payload) {
        commit(action.AUTH_SAVE_TOKEN, payload)
    },

    async [action.AUTH_FETCH_USER]({ commit }) {
        const { data } = await axios.get('/api/user/getAuth')

        commit(action.AUTH_FETCH_USER, { user: data })
    },

    async [action.AUTH_LOGOUT]({ commit }) {
        await axios.post('/api/logout')

        commit(action.AUTH_LOGOUT)
    },

    [action.AUTH_CLEAR]({ commit }) {
        commit(action.AUTH_LOGOUT)
    },
}

// getters
export const getters = {
    [getter.AUTH_USER]: (state) => state.user,
    [getter.AUTH_TOKEN]: (state) => state.token,
    [getter.AUTH_CHECK]: (state) => state.user.id,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js